// @ts-nocheck
import { Link } from 'react-router-dom';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Badge } from '@/components/ui/badge';
import { ExternalLink } from 'lucide-react';
import SectionCard from './SectionCard';

export default function OverviewSection({ d, registrationName }) {
  const { draft, setField, dirtyBySection, savingSection, saveSection, contestType, registration } = d;
  const isTournament = contestType === 'tournament';

  return (
    <SectionCard
      id="overview"
      title="Overview"
      description="What this registration is for, and whether it's live."
      dirty={dirtyBySection.overview}
      saving={savingSection === 'overview'}
      onSave={() => saveSection('overview')}
    >
      <div className="flex flex-wrap items-center gap-3 rounded-lg border bg-muted/40 p-4">
        <div className="min-w-0 flex-1">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
            Linked {isTournament ? 'tournament' : 'season'}
          </div>
          <div className="truncate text-base font-semibold">{registrationName || '—'}</div>
        </div>
        <Badge variant="outline" className="capitalize">{isTournament ? 'Tournament' : 'Season'}</Badge>
        <Link
          to={`/admin/registration/${registration?._id}`}
          className="inline-flex items-center gap-1 text-sm text-primary hover:underline"
        >
          Registration dashboard <ExternalLink className="h-3.5 w-3.5" />
        </Link>
      </div>

      <div className="space-y-2 rounded-lg border p-4">
        <div className="flex items-center gap-2">
          <Switch id="reg-active" checked={!!draft.active} onCheckedChange={(v) => setField('active', v)} />
          <Label htmlFor="reg-active" className="text-base font-medium">Active</Label>
        </div>
        <p className="pl-10 text-sm text-muted-foreground">
          When on, this registration is live: it appears on your public site and can accept teams
          (subject to the open/close dates below). Turn off to unpublish it without deleting anything.
        </p>
      </div>

      <div className="space-y-2 rounded-lg border p-4">
        <div className="flex items-center gap-2">
          <Switch
            id="show-all-teams"
            checked={!!draft.showAllRegistrationTeams}
            onCheckedChange={(v) => setField('showAllRegistrationTeams', v)}
          />
          <Label htmlFor="show-all-teams" className="text-base font-medium">Show all teams publicly</Label>
        </div>
        <p className="pl-10 text-sm text-muted-foreground">
          Publicly list all registered teams (grouped by division) on the registration details page.
        </p>
      </div>
    </SectionCard>
  );
}
